const LOGO_SRC = "https://caru.bbbprograms.org/seal/GetSeal/1360985602";

const createImg = (id, src) => {
  const img = document.createElement("img");
  img.src = src;
  img.id = id;
  img.alt = 'WildBrain Family International Limited confirmation seal';
  img.width = "150";
  img.height = "58";
  img.style.border = "0";
  return img;
};

class caruLogo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.appendChild(createImg("caru-logo", LOGO_SRC));
    const imgLink = '<a target="_blank" title="Click for the Privacy Confirmation of WildBrain Family International Limited " href="https://caru.bbbprograms.org/seal/Confirmation/1360985602">'  + 
                    this.innerHTML + 
                 '</a>';
    this.innerHTML = imgLink;
   }
}

customElements.define("caru-logo", caruLogo);